@if (udid() !== undefined) {
  <era-panel>
    <ml-async-result [operation]="apple$">
      @if (apple$ | async; as apple) {
        <div class="p-2">
          <era-pane>
            <div class="d-flex justify-content-between row">
              <h5 class="col-auto small-caps"
                  i18n>OS Updates</h5>
              @if (apple.isSupervised) {
                <ml-mdm-command-spinner [commandProgress]="updateCommandProgress"
                                        [small]="true"
                                        [direction]="'right'"
                                        [reverse]="true"
                                        class="col text-end">
                  <button type="button"
                          (click)="refresh()"
                          [class]="'btn btn-outline-primary border-0'">
                    <fa-icon icon="sync"></fa-icon>
                  </button>
                </ml-mdm-command-spinner>
              }
            </div>
            <table class="table table-sm table-list mb-4">
              <thead>
                <tr>
                  <th colspan="2"
                      scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th title="The version of iOS the device is running."
                      data-toggle="tooltip"
                      data-placement="right"
                      scope="row">
                    Current OS Version
                  </th>
                  <td>{{ apple.osVersion }}</td>
                </tr>
              </tbody>
            </table>
            @if (availableOsUpdates$ | async; as osUpdates) {
              <div>
                @if (osUpdates?.length > 0) {
                  <div>
                    <h5 class="small-caps mb-2">Available Updates</h5>
                    <div ngbAccordion
                         #acc="ngbAccordion">
                      @for (osUpdate of osUpdates; track osUpdate) {
                        <div ngbAccordionItem>
                          <h2 ngbAccordionHeader
                              class="d-flex align-items-center justify-content-between">
                            <button ngbAccordionButton
                                    class="flex-grow-1 text-start btn btn-link p-2">
                              {{ osUpdate.humanReadableName }}
                            </button>
                            <button type="button"
                                    (click)="openUpdatesModal(osUpdate)"
                                    [class]="'btn btn-outline-primary border-0'">
                              <fa-icon icon="upload"></fa-icon>
                            </button>
                          </h2>
                          <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                              <table class="table table-sm table-list mb-4">
                                <thead>
                                  <tr>
                                    <th colspan="2"
                                        scope="col"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th scope="row"
                                        title="The product key that represents this update."
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        i18n>
                                      Product Key
                                    </th>
                                    <td>
                                      {{ osUpdate.productKey }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row"
                                        title="The human-readable name of the software update, in the current user’s current locale."
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        i18n>
                                      Human Readable Name
                                    </th>
                                    <td>
                                      {{ osUpdate.humanReadableName }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row"
                                        title="The product name: e.g., iOS."
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        i18n>
                                      Product Name
                                    </th>
                                    <td>
                                      {{ osUpdate.productName }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row"
                                        title="The version of the update: e.g., 9.0."
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        i18n>
                                      Version
                                    </th>
                                    <td>
                                      {{ osUpdate.version }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row"
                                        title="The build number of the update: e.g., 13A999."
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        i18n>
                                      Build
                                    </th>
                                    <td>
                                      {{ osUpdate.build }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row"
                                        title="Storage size needed to download the software update. Floating point number of bytes."
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        i18n>
                                      Download Size
                                    </th>
                                    <td>
                                      {{
                            osUpdate.downloadSize && osUpdate.downloadSize > 0
                            ? (osUpdate.downloadSize | bytesToMb | number: '1.1-2') + ' MB'
                            : 'N/A'
                            }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row"
                                        title="Storage size needed to install the software update. Floating point number of bytes."
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        i18n>
                                      Install Size
                                    </th>
                                    <td>
                                      {{
                            osUpdate.installSize && osUpdate.installSize > 0
                            ? (osUpdate.installSize | bytesToMb | number: '1.1-2') + ' MB'
                            : 'N/A'
                            }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row"
                                        title="Storage size needed to install the software update. Floating point number of bytes."
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        i18n>
                                      Is Critical
                                    </th>
                                    <td>
                                      <ml-yes-no-icon [flag]="osUpdate.isCritical"></ml-yes-no-icon>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row"
                                        title="Set to true if the device restarts after this update is installed. Defaults to false."
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        i18n>
                                      Restart Required
                                    </th>
                                    <td>
                                      <ml-yes-no-icon [flag]="osUpdate.restartRequired"></ml-yes-no-icon>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row"
                                        title="Set to true if the update is eligible for InstallLater. Defaults to true."
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        i18n>
                                      Allows InstallLater
                                    </th>
                                    <td>
                                      <ml-yes-no-icon [flag]="osUpdate.allowsInstallLater"></ml-yes-no-icon>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            @if (availableLookupOsUpdates$ | async; as lookupOsUpdates) {
              <div>
                @if (lookupOsUpdates?.length > 0) {
                  <div>
                    <h5 class="small-caps mt-4 mb-2">Available Updates From Lookup Service</h5>
                    <div ngbAccordion
                         #acc="ngbAccordion">
                      @for (osUpdate of lookupOsUpdates; track osUpdate) {
                        <div ngbAccordionItem>
                          <h2 ngbAccordionHeader
                              class="d-flex align-items-center justify-content-between">
                            <button ngbAccordionButton
                                    class="flex-grow-1 text-start btn btn-link p-2">
                              {{ osUpdate.productVersion }}
                            </button>
                            <button type="button"
                                    (click)="openLookupUpdatesModal(osUpdate)"
                                    class="btn btn-outline-primary border-0 btn-sm ms-2">
                              <fa-icon icon="upload"></fa-icon>
                            </button>
                          </h2>
                          <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                              <table class="table table-sm table-list mb-4">
                                <tbody>
                                  <tr>
                                    <th scope="row"
                                        title="The version of the update: e.g., 9.0."
                                        i18n>Version</th>
                                    <td>{{ osUpdate.productVersion }}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row"
                                        title="The Expiration Date."
                                        i18n>Expiration Date</th>
                                    <td>{{ osUpdate.expirationDate | date: 'dd/MM/yyyy' }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </era-pane>
        </div>
      }
    </ml-async-result>
    <ml-async-result [operation]="osUpdateState$">
      @if (osUpdateState$ | async; as osUpdateStates) {
        <div class="p-2">
          <era-pane>
            <div class="d-flex justify-content-between row">
              <h5 class="col-auto small-caps"
                  i18n>OS Update State</h5>
              <ml-mdm-command-spinner [commandProgress]="refreshStateCommandProgress"
                                      [small]="true"
                                      [direction]="'right'"
                                      [reverse]="true"
                                      class="col text-end">
                <button type="button"
                        (click)="refreshUpdateState()"
                        [class]="'btn btn-outline-primary border-0'">
                  <fa-icon icon="sync"></fa-icon>
                </button>
              </ml-mdm-command-spinner>
            </div>
            @if (osUpdateStates.length === 0) {
              <div>No update status found</div>
            } @else {
              <table class="table table-sm table-list mb-4">
                <thead>
                  <tr>
                    <th colspan="2"
                        scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th title="The current OS update state of the device."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Current State
                    </th>
                    @for (osUpdateState of osUpdateStates; track osUpdateState) {
                      <td>{{ osUpdateState.status }}</td>
                    }
                  </tr>
                  <tr>
                    <th title="The current OS update state of the device."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Download Percent Complete
                    </th>
                    @for (osUpdateState of osUpdateStates; track osUpdateState) {
                      <td>
                        {{ $safeNavigationMigration(osUpdateState?.downloadPercentComplete) * 100 | number: '1.0-10' }}%
                      </td>
                    }
                  </tr>
                  <tr>
                    <th title="The current OS update state of the device."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Product Key
                    </th>
                    @for (osUpdateState of osUpdateStates; track osUpdateState) {
                      <td>{{ osUpdateState.productKey }}</td>
                    }
                  </tr>
                  <tr>
                    <th title="The current OS update state of the device."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Deferrals Remaining
                    </th>
                    @for (osUpdateState of osUpdateStates; track osUpdateState) {
                      <td>{{ osUpdateState.deferralsRemaining }}</td>
                    }
                  </tr>
                  <tr>
                    <th title="The current OS update state of the device."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Max Deferrals
                    </th>
                    @for (osUpdateState of osUpdateStates; track osUpdateState) {
                      <td>{{ osUpdateState.maxDeferrals }}</td>
                    }
                  </tr>
                  <tr>
                    <th title="The current OS update state of the device."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Next Scheduled Install
                    </th>
                    @for (osUpdateState of osUpdateStates; track osUpdateState) {
                      <td>{{ osUpdateState.nextScheduledInstall | date: 'short' }}</td>
                    }
                  </tr>
                  <tr>
                    <th title="The current OS update state of the device."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Past Notifications
                    </th>
                    @for (osUpdateState of osUpdateStates; track osUpdateState) {
                      @for (date of osUpdateState.pastNotifications; track date) {
                        <td>{{ date | date: 'short' }}</td>
                      }
                    }
                  </tr>
                </tbody>
              </table>
            }
          </era-pane>
        </div>
      }
    </ml-async-result>
  </era-panel>
}